









































import { defineComponent } from '@vue/composition-api';
import { AppCustomerGenericNotificationApiViewQuery_customers } from './__generated__/AppCustomerGenericNotificationApiViewQuery';
import query from './view.gql';

interface NotificationApiProps {
  customerId: string;
}

interface NotificationApiData {
  customers?: AppCustomerGenericNotificationApiViewQuery_customers;
}

export default defineComponent<NotificationApiProps, Record<string, unknown>, NotificationApiData>({
  props: {
    customerId: { type: String, required: true },
  },
  data(): NotificationApiData {
    return { customers: undefined };
  },
  apollo: {
    customers: {
      query,
      fetchPolicy: 'cache-and-network',
      variables() {
        return { customerId: this.customerId };
      },
    },
  },
});
